//Util to get last route path
const getLastRoutePath = pathName => {
  return pathName.split('/').pop()
}

export { getLastRoutePath }

let navigateFunc

/**
 * Sets the navigation function that can be used from anywhere in the app.
 * @param {import('@remix-run/router').Router['navigate']} navigate - The navigate function from the router instance.
 */
export const setNavigate = navigate => {
  navigateFunc = navigate
}

/**
 * Redirects the user to the error page with a specific error type.
 * @param {('network'|'server'|'unexpected')} type - The type of error.
 */
export const redirectToErrorPage = (type, status) => {
  if (navigateFunc) {
    // We use router.navigate for SPA-style navigation without a full page reload.
    let path = `/error?type=${type}`;
    if (status !== undefined && status !== null) {
      path += `&status=${status}`;
    }
    navigateFunc(path);
  }
}
